
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import ModalHeader from './modal-header';
import ModalBody from './modal-body';
import ModalFooter from './modal-footer';
import { Title } from '../type';

export const ModalTitle = styled(Title)`
	margin-bottom: 0;
`;

const Overlay = styled(DialogPrimitive.Overlay)`
	position: fixed;
	display: flex;
	align-items: center;
	justify-content: center;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: hsl(var(--black) / 0.75);
	z-index: 100;
`;

const ContentInner = styled(DialogPrimitive.Content)`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	max-width: calc(100% - 3.5rem);
	max-height: calc(100% - 3.5rem);
	background: hsl(var(--card));
	overflow: auto;
	-webkit-overflow-scrolling: touch;
	border-radius: 0.25rem;
	outline: none;
	color: hsl(var(--card-foreground));
	z-index: 101;

	& > * {
		&:not(:last-child) {
			margin-bottom: 1rem;
		}
	}
`;

function getSizeWidth(size) {
	if(typeof size === 'number') {
		return `${size}px`;
	}
	switch(size) {
		case 'sm': return '300px';
		case 'lg': return '800px';
		case 'xl': return '1200px';
		default: return '600px';
	}
}

function Modal({
	isOpen, onRequestClose, shouldCloseOnOverlayClick = true, size, contentLabel, children, ...props
}) {
	function handleOpenChange(open) {
		if(!open && onRequestClose) {
			onRequestClose();
		}
	}

	const ariaLabel = props['aria-label'] || contentLabel;

	return (
		<DialogPrimitive.Root open={isOpen} onOpenChange={handleOpenChange}>
			<DialogPrimitive.Portal>
				<Overlay />
				<ContentInner
					style={{ width: getSizeWidth(size) }}
					aria-label={ariaLabel}
					onInteractOutside={(e) => {
						if(!shouldCloseOnOverlayClick) {
							e.preventDefault();
						}
					}}
					onEscapeKeyDown={(e) => {
						if(!onRequestClose) {
							e.preventDefault();
						}
					}}
					{...props}
				>
					{children}
				</ContentInner>
			</DialogPrimitive.Portal>
		</DialogPrimitive.Root>
	);
}

Modal.propTypes = {
	isOpen: PropTypes.bool,
	onRequestClose: PropTypes.func,
	shouldCloseOnOverlayClick: PropTypes.bool,
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	contentLabel: PropTypes.string,
	'aria-label': PropTypes.string,
	children: PropTypes.node
};

Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.Title = ModalTitle;

export default Modal;
